import { render, staticRenderFns } from "./addValue.vue?vue&type=template&id=36215b1f&scoped=true"
import script from "./addValue.vue?vue&type=script&lang=js"
export * from "./addValue.vue?vue&type=script&lang=js"
import style0 from "./addValue.vue?vue&type=style&index=0&id=36215b1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36215b1f",
  null
  
)

export default component.exports